import React from 'react';

interface PropsType {
  dailyCancelRules?: any;
  pickupCancelRules?: any;
}

const TemplateSelect:React.FC<PropsType> = (props) => {
  const { pickupCancelRules } = props || {};

  return (
    <>
      {(pickupCancelRules || []).map((item: any) => {
        if (item.from > 0 && item.to === -1) {
          return (<p>取车前 {item.from} 小时（含），免费取消</p>);
        }
        if (item.from !== -1 && item.to > 0) {
          return (<p>取车前 {item.from} 小时至 {item.to}小时，按照订单总金额 {item.percent}% 作为违约金</p>);
        }
        if (item.from > 0 && item.to === 0) {
          return (<p>取车前 {item.from} 小时内，按照订单总金额 {item.percent}% 作为违约金</p>);
        }
        if (item.from === -1 && item.to === -1) {
          return (<p>超过取车时间，按照订单总金额收取 100% 作为违约金</p>);
        }
        return '';
      })}
    </>
  )
}

export default TemplateSelect;
